<div class="section">
	<particles></particles>
	<div class="sectionDivider">
		<h5>
			<ng-content select="[headline]"></ng-content>
			<div class="trapezoidal"></div>
		</h5>
	</div>
	<div *ngIf="ornament == 'right'" class="ornamentRight"></div>
	<div *ngIf="ornament == 'left'" class="ornamentLeft"></div>
	<div class="container">
		<ng-content></ng-content>
	</div>
</div>
